import React from 'react'
import styles from "../style/components/accountSidebar.module.css"
import axios from "axios"
import { Link } from 'react-router-dom'
import Modal from './Modal'
import {useState} from "react"

const ADMIN_ID = process.env.REACT_APP_ADMIN_ID

const AccountSidebar = ({setIsAuth, setUser, user, setLoadVideoModal}) => {
	const handleClickLogout = async () => {
		try {
			const res = await axios.post("https://rishat-tour.ru/api/auth/logout")
			console.log(res)
			setIsAuth(false)
			setUser({})
			localStorage.removeItem("token")

			window.location.href = "/"
		} catch (e) {
			console.log(e)
		}

	}
  return (
	<div className={styles.accountSidebar}>
		<div className={styles.accountItem}>
			<img src='/like null.svg' alt=""/>
			<Link to="/favourites">Избранный</Link>
		</div>
		<div className={styles.accountItem}>
			<img src='/product.svg' alt=""/>
			<Link to='/purchased'>Приобретенные товары</Link>
		</div>

		{
		user?._id === ADMIN_ID && 
			<div className={styles.accountItem} onClick={() => setLoadVideoModal(true)}>
				<img src='/exit account.svg' alt=""/>
			<span>Загрузить видео</span>
		</div>
		}
		<div className={styles.accountItem} onClick={handleClickLogout}>
			<img src='/exit account.svg' alt=""/>
			<span>Выйти</span>
		</div>


	</div>
  )
}

export default AccountSidebar
